import { render, staticRenderFns } from "./PopChatUploader.vue?vue&type=template&id=a186552a&lang=pug"
import script from "./PopChatUploader.vue?vue&type=script&lang=js"
export * from "./PopChatUploader.vue?vue&type=script&lang=js"
import style0 from "./PopChatUploader.vue?vue&type=style&index=0&id=a186552a&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports